module.exports = __webpack_public_path__ + "static/media/Servicos3.810cdc84.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadServicos/Servicos3.png
// module id = 2117
// module chunks = 0